import { FC } from "react";

import { Badge, BadgeSize, BadgeVariant } from "./ui/Badge";

import noiseBackground from "@/assets/noise-background.png";
import { AUTH_CONFIG } from "@/constants";

interface AuthSubmitButtonProps {
  loading: boolean;
  text: string;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const AuthSubmitButton: FC<AuthSubmitButtonProps> = ({
  loading,
  text,
  disabled,
  onClick,
  className,
}) => {
  const buttonContent = loading ? "Loading..." : text;
  const lastLoginType = localStorage.getItem("last_login_type");
  const isLoginPage = window.location.pathname.includes("login");
  const { isOnPrem } = AUTH_CONFIG;

  return (
    <button
      className={`relative mt-6 w-full rounded-lg px-[18px] py-2.5 text-white phone:mt-2 ${className} ${
        loading || disabled
          ? "bg-gray-400"
          : "border border-[#1D4ED8] bg-[#1D4ED8] shadow-sm hover:bg-[#1D4ED8]/90"
      }`}
      disabled={loading || disabled}
      type="submit"
      onClick={onClick}
      style={{
        backgroundImage: `url(${noiseBackground})`,
        backgroundRepeat: "repeat",
        backgroundBlendMode: "overlay",
        backgroundSize: "contain",
      }}
    >
      {lastLoginType === "email" && !isOnPrem && isLoginPage && (
        <Badge
          variant={BadgeVariant.BLUE}
          size={BadgeSize.SM}
          className="absolute -right-3 -top-2.5 flex items-center gap-2 !text-xs shadow-sm"
        >
          Last used
        </Badge>
      )}
      {buttonContent}
    </button>
  );
};

export default AuthSubmitButton;
